(function(){
      const KEY = "preferred_size";

      function initHoverSizes(root){
        const cards = (root || document).querySelectorAll(".product-card.has-hover-sizes .card-hover-sizes");
        cards.forEach(panel => {
          if(panel.dataset.hooked === "1") return;
          panel.dataset.hooked = "1";

          const mapStr = panel.getAttribute("data-variant-map") || "{}";
          let variantMap = {};
          try{ variantMap = JSON.parse(mapStr); }catch(e){}

          const form = panel.querySelector(".card-hover-sizes__form");
          const input = panel.querySelector(".card-hover-sizes__variant-id");
          const addBtn = panel.querySelector(".card-hover-sizes__add");
          const btns = panel.querySelectorAll(".card-hover-sizes__btn");

          function setActiveSize(size){
            btns.forEach(b => b.classList.toggle("is-active", b.dataset.size === size));
            const vid = variantMap[size];
            if(vid){
              input.value = String(vid);
              addBtn.disabled = false;
              addBtn.classList.add("is-enabled");
            }else{
              input.value = "";
              addBtn.disabled = true;
              addBtn.classList.remove("is-enabled");
            }
          }

          const saved = localStorage.getItem(KEY);
          if(saved && variantMap[saved]) setActiveSize(saved);

          btns.forEach(btn => {
            btn.addEventListener("click", () => {
              const size = btn.dataset.size;
              localStorage.setItem(KEY, size);
              setActiveSize(size);
            });
          });

          form.addEventListener("submit", (e) => {
            if(!input.value){
              e.preventDefault();
            }
          });
        });
      }

      document.addEventListener("DOMContentLoaded", () => initHoverSizes(document));
      document.addEventListener("shopify:section:load", (e) => initHoverSizes(e.target));
    })();

(function () {
  function revealApps() {
    var section = document.querySelector('.shopify-section--apps');
    if (!section) return;

    section.setAttribute('data-lazy-reveal', '');

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        section.removeAttribute('data-lazy-reveal');
        io.disconnect();
      }
    }, { rootMargin: '300px 0px' });

    io.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealApps);
  } else {
    revealApps();
  }
})();